// apps/hub/src/components/BetaBadge.tsx
// Badge bêta réutilisable — utilisé dans HubLayout et HomePage
// Retirez le badge (et l'entrée NAV_ITEMS.beta) quand la feature passe en stable.

export default function BetaBadge() {
  return (
    <span
      className="ml-1.5 inline-flex items-center rounded-full border border-[#7c5cff]/40 bg-gradient-to-r px-1.5 py-0.5 text-[10px] font-bold uppercase leading-none tracking-wider text-white motion-safe:animate-pulse"
      aria-label="Fonctionnalité en bêta"
    >
      bêta
    </span>
  )
}
